import { createFont, isWeb } from 'tamagui'

const fontSizeTokens = {
  0: 10,
  1: 12,
  2: 14,
  3: 16,
  4: 18,
  5: 20,
  6: 24,
  7: 32,
  8: 40,
  9: 48,
  10: 56,
  entrataHeadline: 33,
  entrataSubheading: 24,
  entrataBody: 17,
  entrataTextLinkLarge: 15,
  entrataTextLinkSmall: 13,
}
const lineHeightTokens = { 0: 16, 1: 18, 2: 20, 3: 21, 4: 24, 5: 28, 6: 32, 7: 40, 8: 48, 9: 56, 10: 64 }
const weightTokens = { thin: '100', extralight: '200', light: '300', regular: '400', medium: '500', semibold: '600', bold: '700', extrabold: '800', black: '900' }

export const robotoFont = createFont({
  family: isWeb ? 'Roboto, system-ui, sans-serif' : 'Roboto',
  size: fontSizeTokens,
  lineHeight: lineHeightTokens,
  weight: weightTokens,
})

export const workSansFont = createFont({
  family: isWeb ? 'Work Sans, system-ui, sans-serif' : 'WorkSans',
  size: fontSizeTokens,
  lineHeight: lineHeightTokens,
  weight: weightTokens,
})

export const entrataFont = createFont({
  family: isWeb ? "'Sohne', system-ui, sans-serif" : 'Sohne',
  size: fontSizeTokens,
  lineHeight: lineHeightTokens,
  weight: {
    ...weightTokens,
    entrataRegular: '400',
    entrataBold: '500',
  },
})


